import { useEffect, useRef, useState } from 'react';
import { Helmet } from 'react-helmet';
import ApplicationLayout from '../../../layouts/ApplicationLayout';
import TapIcon from '../../../services/TapIcon';
import { useSelector } from 'react-redux';
import HttpAPICall from '../../../services/HttpAPICall';
import { toast } from 'react-toastify';
import { BACKOFFICE_BASE_URL } from '../../../services/TapApiUrls';

const AddDeviceType = ({ history, location }) => {
    const access_token = useSelector(state => state.auth.access_token);
    const [submitLoading, setSubmitLoading] = useState(false)
    const [formData, setFormData] = useState({
        id: "",
        name: "",
        is_child: 0
    })
    const [isEditMode, setIsEditMode] = useState(false)

    const backToListing = () => {
        history.push({ pathname: '/device_type' });
    }
    useEffect(() => {
        initialFormData()
    }, []);

    const initialFormData = () => {
        if (location?.state?.editDeviceTypeData) {
            setFormData({
                id: location.state.editDeviceTypeData.id || "",
                name: location.state.editDeviceTypeData.name || "",
                is_child: location.state.editDeviceTypeData.is_child ?? 0
            });
            setIsEditMode(true);
        }
    };

    const submitDataForm = (e) => {
        e.preventDefault();

        setSubmitLoading(true)
        if (isEditMode == true) {
            HttpAPICall.withAthorization('PUT', BACKOFFICE_BASE_URL + '/device_type_edit', access_token, {}, formData, (resp) => {
                toast.success(resp.data.msg, { position: toast.POSITION.TOP_RIGHT });
                history.push({ pathname: '/device_type', state: { id: formData.id } });
            }).then(() => setSubmitLoading(false));
        } else {
            HttpAPICall.withAthorization('POST', BACKOFFICE_BASE_URL + '/device_type_add', access_token, {}, formData, (resp) => {
                toast.success(resp.data.msg, { position: toast.POSITION.TOP_RIGHT });
                backToListing();
            }).then(() => setSubmitLoading(false))
        }
    }
    const formInputHandler = (e) => {
        setFormData(pre => ({ ...pre, [e.target.name]: e.target.value }));
    };

    const formDatajsx = () => {
        return (
            <>
                <form className="bg-white p-3" onSubmit={submitDataForm} id="saveResourceForm">
                    <div className="row align-items-center my-3">
                        <div className="col-sm-3">
                            <label htmlFor="path" className="form-label require">Device Type</label>
                        </div>
                        <div className="col-sm-8 ">
                            <input
                                name="name"
                                type="text"
                                value={formData.name}
                                className="form-control"
                                autoComplete="off"
                                required={true}
                                onChange={formInputHandler}
                                placeholder="Please enter Device Type Name"

                            />
                        </div>
                    </div>
                    <div className="row align-items-center my-3">
                        <div className="col-sm-3">
                            <label className="form-label require">Is Child</label>
                        </div>
                        <div className="col-sm-8 d-flex gap-4">
                            <div className="form-check">
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    name="is_child"
                                    id="isChild1"
                                    value={1}
                                    checked={Number(formData.is_child) === 1}
                                    onChange={(e) =>
                                        setFormData(pre => ({ ...pre, is_child: Number(e.target.value) }))
                                    }
                                />
                                <label className="form-check-label" htmlFor="isChild1">
                                    Yes
                                </label>
                            </div>
                            <div className="form-check">
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    name="is_child"
                                    id="isChild0"
                                    value={0}
                                    checked={Number(formData.is_child) === 0}
                                    onChange={(e) =>
                                        setFormData(pre => ({ ...pre, is_child: Number(e.target.value) }))
                                    }
                                />
                                <label className="form-check-label" htmlFor="isChild0">
                                    No
                                </label>
                            </div>
                        </div>
                    </div>

                    <div className="col-12 text-end fixed_footer">
                        <button type="button" className="btn btn-secondary mx-3" onClick={backToListing} disabled={submitLoading}>Cancel</button>
                        <button type="submit" className="btn btn-primary mx-2" disabled={submitLoading}>
                            Save {submitLoading ? (<TapIcon.FontAwesomeIcon icon={TapIcon.faSyncAlt} className="fa-spin" />) : ''}
                        </button>
                    </div>
                </form>
            </>
        );
    };
    const addDeviceTypeJsx = () => {
        return (
            <>
                <div className="page_title row m0">
                    <div className="col-12">
                        <h3> {isEditMode ? "Edit " : "Add "} Device Type</h3>
                        <div className="text-end mt15">
                            <>
                                <button type="button" className="btn btn-secondary" onClick={backToListing}>
                                    <TapIcon.imageIcon icon={TapIcon.CloseIcon} className="img-fluid" alt="item-action" />
                                </button>
                            </>
                        </div>
                    </div>
                </div>
                <div className="container-fluid pl5">
                    <div className="page_containt row">
                        <div className={['pageTbl', 'col-12'].join(' ')}>{formDatajsx()}</div>
                    </div>
                </div>
            </>
        );
    };
    return (
        <ApplicationLayout>
            <Helmet><title>Add Device Type</title></Helmet>
            {addDeviceTypeJsx()}
        </ApplicationLayout>
    );
};

export default AddDeviceType;